import {INITDATA} from './actionTypes';
            
export const initAnimalsData = () => ({ type: INITDATA });
